import axios from 'axios';

import UploadGCS from '@cognite/gcs-browser-upload';

export const chunkMultiple = (fileSize: number) => {
  return Math.min(
    Math.max(
      2, // at least 2 chunks
      Math.ceil(fileSize / 20 / 262144) // Calculate the number of 256 KB chunks in 1/20th of the image size
    ),
    200 // no more than 200 chunks
  );
};

export type UploadToGCSDeps = { UploadGCS: typeof UploadGCS };
const defaultUploadToGCSDeps: UploadToGCSDeps = { UploadGCS };

export const uploadToGCS = async ({
  file,
  url,
  deps = defaultUploadToGCSDeps,
}: {
  file: File;
  url: string;
  deps?: UploadToGCSDeps;
}): Promise<void> => {
  const chunkedFile = chunkMultiple(file.size);

  await new deps.UploadGCS({
    id: 'datastudio-upload',
    url,
    file: file,
    contentType: file.type,
    chunkSize: 262144 * chunkedFile,
  }).start();
};

export type UploadViaAxiosDeps = { axios: typeof axios };
const defaultUploadViaAxiosDeps: UploadViaAxiosDeps = { axios };

export const uploadViaAxios = async ({
  file,
  url,
  deps = defaultUploadViaAxiosDeps,
}: {
  file: File;
  url: string;
  deps?: UploadViaAxiosDeps;
}): Promise<void> => {
  await deps.axios({
    method: 'PUT',
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    headers: {
      'Content-Type': file.type,
    },
    url: url,
    data: file,
  });
};
